import type { ReactNode } from "react";
import { cn } from "../lib/cn";
import { Text } from "./text";

export type EmptyStateProps = {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
  icon?: ReactNode;
};

export function EmptyState({
  title,
  description,
  action,
  className,
  icon,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center px-6 py-10 text-center",
        className
      )}
    >
      {icon ? <div className="mb-4 text-foreground-subtle">{icon}</div> : null}
      <Text variant="heading" as="h2">
        {title}
      </Text>
      {description ? (
        <Text variant="muted" className="mt-2 max-w-sm">
          {description}
        </Text>
      ) : null}
      {action ? <div className="mt-5 w-full max-w-xs">{action}</div> : null}
    </div>
  );
}
